import React from 'react';
import styled from 'styled-components';
import { keyframes } from 'styled-components';
import loadingIcon from 'utils/icon/icon_loading.png';
import loadingIconWhite from 'utils/icon/icon_loading-white.png';

interface IProps {
  color: string;
}

const CircleLoader: React.FC<IProps> = ({ color }) => {
  return (
    <InfiniteRotate>
      <img
        src={color === 'white' ? loadingIconWhite : loadingIcon}
        alt='loading'
      />
    </InfiniteRotate>
  );
};

export default CircleLoader;

const rotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const InfiniteRotate = styled.div`
  animation: ${rotate} 2s linear infinite;
`;
